var _g, _circle, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_492_12968)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.1265 11.6135H12.9907C11.9657 11.6135 11.1348 12.4445 11.1348 13.4695V24.6053C11.1348 25.6303 11.9657 26.4613 12.9907 26.4613H24.1265C25.1516 26.4613 25.9825 25.6303 25.9825 24.6053V13.4695C25.9825 12.4445 25.1516 11.6135 24.1265 11.6135Z",
    fill: "#37994F",
    stroke: "#37994F",
    strokeWidth: 1.85597,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8477 18.1097V22.7496",
    stroke: "white",
    strokeWidth: 1.85597,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8477 15.326V15.3377",
    stroke: "white",
    strokeWidth: 1.85597,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5605 22.7496V18.1097",
    stroke: "white",
    strokeWidth: 1.85597,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2725 22.7496V19.9656C22.2725 19.4734 22.0769 19.0013 21.7289 18.6533C21.3808 18.3052 20.9087 18.1097 20.4165 18.1097C19.9243 18.1097 19.4522 18.3052 19.1041 18.6533C18.7561 19.0013 18.5605 19.4734 18.5605 19.9656",
    stroke: "white",
    strokeWidth: 1.85597,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.5597,
    cy: 19.0373,
    r: 17.8637,
    stroke: "#37994F",
    strokeWidth: 1.39198
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_492_12968"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.2716,
    height: 22.2716,
    fill: "white",
    transform: "translate(7.42383 7.90125)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.ee0ad5894fb2ce5ca20fd7653d93e40a.svg";
export { ForwardRef as ReactComponent };